import {Block} from '@material-ui/icons';
import React from 'react';

import {useTranslation} from 'react-i18next';
import DetachedIcon from '../../../shared/components/detachedIcon';

const EmptyElectionsSection: React.FC = () => {
  const {t} = useTranslation();

  return (
    <>
      <DetachedIcon size="sm" icon={<Block />} />
      <h4 className="secondary-text text-center">
        {t('estado-vazio-eleicao.sem-eleicoes-ativas')}
      </h4>
    </>
  );
};

export default EmptyElectionsSection;



// WEBPACK FOOTER //
// ./src/features/election/components/EmptyElectionsSection.tsx